import {
  ConfirmButton,
  FooterQuantityField,
} from 'menu/components/MenuModal/MenuModalFooter';
import { getSelectedPortion } from 'menu/utils';
import { AztecProduct } from 'types/models';

interface MenuModalFooterProps {
  aztecProduct: AztecProduct;
  updateAztecProduct: (product: AztecProduct) => void;
  handleConfirm: () => void;
}

export const MenuModalFooter: React.FC<MenuModalFooterProps> = ({
  aztecProduct,
  updateAztecProduct,
  handleConfirm,
}) => {
  const selectedPortion = getSelectedPortion(aztecProduct);

  if (!selectedPortion) {
    return null;
  }

  return (
    <div className="menu-modal-footer">
      <div className="menu-modal-footer-container">
        <FooterQuantityField
          aztecProduct={aztecProduct}
          updateAztecProduct={updateAztecProduct}
        />
        <ConfirmButton
          aztecProduct={aztecProduct}
          handleConfirm={handleConfirm}
        />
      </div>
    </div>
  );
};
